import React from "react";
import "./../../style.scss";
import { withStyles, Table, Paper, withTheme } from "@material-ui/core";
import styles from "./styles";
import { formatAddress } from "../../../../modules/Dispatch/utils/utils";
import  Header  from "../components/Header";
import Content from "../components/Content";
import Footer  from "../components/Footer";
import Contact from "../components/Contact";
import { getDeliveryStopContact, getDriverDetails, getDeliveryContent } from "../utils";
import ShowProNumbers from "../components/ShowProNumbers";
import { DeliveryPopupMarker } from "../../../Markers";
import { compose } from "recompose";

const StopDeliveryPopupInfo = ({
  classes,
  isDelayStop,
  specialNeeds,
  stopData,
  routesData,
  terminalOffset,
  openDriverChat,
  theme,
}) => {
  const address = formatAddress({
    address: stopData?.address,
    address2: stopData?.address2,
    city: stopData?.city,
    state: stopData?.state,
    zip: stopData?.zip,
  });
  return (
    <Paper className={`popupBGColor ${classes.mapPopupContainer}`}>
      <Table className={classes.table} padding="none">
        <Header
          name={stopData.displayCustomerName}
          address={address}
          id={stopData.accountNumber}
          stopSequence={stopData.stopSequence}
          isDelayStop={isDelayStop}
          Marker={DeliveryPopupMarker}
          themeColors={{
            color: theme.headFontColor
          }}
          customerName={stopData.name}
          mergeIconColor={theme.headFontColor}
        />
        <Contact {...getDeliveryStopContact(stopData)}/>
        <ShowProNumbers
          proNumberList={stopData.shipments.map((pro) => pro.proId)}
        />
        <Content
          data={getDeliveryContent(stopData)}
          stopData={stopData}
          specialNeeds={specialNeeds}
        />
        <Footer
          stopData={stopData}
          driverDetails={getDriverDetails(routesData, terminalOffset)}
          openDriverChat={openDriverChat}
        />
      </Table>
    </Paper>
  );
};

export default compose(withStyles(styles), withTheme())(StopDeliveryPopupInfo);
